import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const POST_CREATE_TAG = 'POST_CREATE_TAG'
export const createTagApi = apiCall(
  POST_CREATE_TAG,
  ({ siteId, ...payload }: { siteId: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/tags`),
    method: 'POST',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_UPDATE_TAG = 'POST_UPDATE_TAG'
export const updateTagApi = apiCall(
  POST_UPDATE_TAG,
  ({
    id,
    siteId,
    ...payload
  }: { id: string; siteId: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/tags/${id}`),
    method: 'PATCH',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_DELETE_TAG = 'POST_DELETE_TAG'
export const deleteTagApi = apiCall(
  POST_DELETE_TAG,
  ({ id, siteId }: { id: string; siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/tags/${id}`),
    method: 'DELETE',
    headers: appApiHeaders(),
  }),
)
